class LuxProductAccordion extends HTMLElement {
  constructor() {
    super();

    this.head = this.querySelector('.lux-product-accordion__head');
    this.button = this.querySelector('.lux-product-accordion__button');

    // ✅ Bind handlers ONCE (fixes removeEventListener issue)
    this.handleToggle = this.toggleAccordion.bind(this);
    this.handleDownloadClick = this.handleDownload.bind(this);
  }

  connectedCallback() {
    // Accordion toggle
    if (this.head) {
      if (!this.hasAttribute('aria-expanded')) {
        this.setAttribute('aria-expanded', 'false');
      }

      this.head.addEventListener('click', this.handleToggle);
    }

    // Download button
    if (this.button) {
      this.button.addEventListener('click', this.handleDownloadClick);
    }
  }

  disconnectedCallback() {
    if (this.head) {
      this.head.removeEventListener('click', this.handleToggle);
    }

    if (this.button) {
      this.button.removeEventListener('click', this.handleDownloadClick);
    }
  }

  toggleAccordion() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', (!isExpanded).toString());
  }

  handleDownload(e) {
    e.stopPropagation(); // prevent accordion from toggling

    let urls = this.button?.dataset?.urls;
    if (!urls) {
      console.warn('No URLs found on button');
      return;
    }

    // ✅ Parse comma-separated textarea input
    const urlList = urls
      .split(',')
      .map(url => url.trim())
      .filter(Boolean);

    if (!urlList.length) {
      console.warn('No valid URLs after parsing');
      return;
    }

    console.log('Downloading files:', urlList);

    // ✅ Trigger downloads
    urlList.forEach((url, index) => {
      setTimeout(() => {
        this.downloadFile(url, index);
      }, index * 300); // 300ms delay between downloads
    });
  }

  downloadFile(url, index) {
    const fileName =
      url.split('/').pop().split('?')[0] || `image-${index + 1}`;

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch: ${url}`);
        }
        return response.blob();
      })
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(err => {
        console.error('Download failed:', err);

        // fallback → open in new tab if blocked
        window.open(url, '_blank');
      });
  }
}

// ✅ Register custom element safely
if (!customElements.get('lux-product-accordion')) {
  customElements.define('lux-product-accordion', LuxProductAccordion);
}